import { z } from 'zod';

export const copilotConfigSchema = z.object({
  configurationGroup: z.string().min(1),
  configurationKey: z.string().min(1),
  configurationType: z
    .literal('Integer')
    .or(z.literal('Boolean'))
    .or(z.literal('String')),
});

export const copilotConfigsSchema = z.array(copilotConfigSchema);

export type CopilotConfig = z.infer<typeof copilotConfigSchema>;

export type CopilotConfigs = z.infer<typeof copilotConfigsSchema>;
